import { useEffect, useState } from 'react';

import Select, { Props as SelectProps } from 'react-select';

import * as S from './styles';

interface ISimpleSelectProps extends SelectProps {
  name: string;
  options: {
    label: string;
    value: string;
  }[];
  setSelectValue?(value: any): void;
  handleChange?(value: any): void;
}

export function SimpleSelect({
  name,
  options,
  setSelectValue,
  handleChange,
  ...rest
}: ISimpleSelectProps) {
  const [groupOptions, setGroupOptions] = useState([]);

  useEffect(() => {
    setGroupOptions([
      { value: null, label: '- SELECIONE -', isDisabled: true },
      ...options,
    ]);
  }, [options]);

  return (
    <S.Container className="simple-select">
      <Select
        classNamePrefix="react-select"
        id={name}
        name={name}
        options={groupOptions}
        isSearchable={false}
        onChange={e => {
          if (setSelectValue) {
            setSelectValue(e);
          }
          if (handleChange) {
            handleChange(e);
          }
        }}
        {...rest}
      />
    </S.Container>
  );
}
